<template>
    <div class="input-wrap">
        <span class="label">{{label}}</span>
        <!-- <input class="input" v-model="value" :placeholder="placeholder" @change="inputChange" /> -->
        <van-field class="input" v-model="value" :type="type" :maxlength="maxlength" :placeholder="placeholder" @change="inputChange" :formatter="formatter"  format-trigger="onBlur"/>
        <span class="unit" v-if="unit">{{unit}}</span>
    </div>
</template>


<script>
export default {
    props: {
        keyValue: {
            type: [String,Number],
            default: ''
        },
        keyName: {
            type: String,
            default: ''
        },
        keyIndex: {
            type: Number,
            default: 0
        },
        label: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'number'
        },
        placeholder: {
            type: String,
            default: ''
        }, 
        unit: {
            type: String,
            default: ''
        }, 
        maxlength: {
            type: Number,
            default: 10
        }
    },
    data() {
        return {
            value: ''
        }
    },
    created() {
        this.$loading.hide()
        this.value = this.keyValue
    },
    methods: {
    formatter(value) {
        var re = /([0-9]+\.[0-9]{2})[0-9]*/;
      // 过滤输入的数字
      // 过滤不以零开头的数
      var patrn = /^([1-9]\d*)(\.\d*[1-9])?$/;
      
      if (patrn.exec(value)) {
           
       return value.replace(re,"$1")
      }else {
          if (value.indexOf('.') != -1) {
             return value.replace(re,"$1")
          }
          return ''
      }
     
      
    },
        inputChange() {
            this.$emit('change', { key: this.keyName, value: this.formatter(this.value), index: this.keyIndex })
        }
    },
    watch: {
        keyValue: function() {
            this.value = this.keyValue
        }
    }
}
</script>

<style lang="less" scoped>
.input-wrap {
    height: 63px;
    display: flex;
    line-height: 63px;
    font-size: 24px;
    font-weight: 400;
    .label {
        width: 180px;
        display: inline-block;
        background-color: #f2f2f2;
        text-align: center;
        flex-shrink: 0;
    }

    .input {
        display: block;
        width: calc(100% - 80px);
        height: 63px;
        line-height: 63px;
        padding: 0 20px;
        border:2px solid #ddd;
        border-left: #fff;
        border-radius: 0;
        // outline: none;
        // -webkit-appearance:none;
        // -webkit-tap-highlight-color:rgba(0,0,0,0);
    }

    .unit {
        display: inline-block;
        width: 84px;
        text-align: center;
        flex-shrink: 0;
    }
}
</style>